import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import ChecklistConfig from './checklist_config';
import ChecklistConfigsService from '../../services/checklist_configs_service';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import _ from 'lodash';

const ChecklistAdd = ({ location }) => {
  const [saved, setSaved] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [warningMessage, setWarningMessage] = useState(null);

  const handleSubmit = (checklistConfiguration) => {
      setSubmitting(true);

      setSuccessMessage(null);
      setErrorMessage(null);

      ChecklistConfigsService.add(checklistConfiguration).then((_) => {
          setSaved(true);
          setSubmitting(false);
      }).catch(err => {
          console.error(err);
          setErrorMessage(i18next.t('messages.error-saving-checklist'));
      });
  };

  if (saved) {
      return <Redirect to={{ pathname: '/config/checklists', state: { successMessage: i18next.t('messages.checklist-saved') } }}/>;
  } else if (errorMessage) {
      return <Redirect to={{ pathname: '/config/checklists', state: { errorMessage: i18next.t('messages.error-saving-checklist') } }}/>;
  } else if (submitting) {
      return <div className="loader">{i18next.t('loading')}</div>;
  } else {
      const backLinkWithParams = { link: { pathname: "/config/checklists", search: location.state?.backLinkSearch } };
      return (
          <div>
            <div className="row">
              <PageTitle title={i18next.t('pages.checklists.add-checklist')} backLinkWithParams={ backLinkWithParams } />
            </div>

            { warningMessage && <Message errorMessage={ warningMessage } messageDismissCallback={ () => setWarningMessage(null) } /> }

            { successMessage && <Message messages={{ state: { successMessage: successMessage } }} messageDismissCallback={ () => setSuccessMessage(null) } /> }

            { location.state && <Message messages={ location } /> }

            <div className="op-content-box tree-form">
              <h4 className="remove-margin-bottom" />
              <div className="row">

                <ChecklistConfig
                    onSubmit={ handleSubmit }
                    onSuccess={ setSuccessMessage }
                    onError={ setErrorMessage }
                    onWarning={ setWarningMessage }
                    backLinkWithParams={ backLinkWithParams } 
                />

              </div>
            </div>
          </div>
      );
  }
}

export default ChecklistAdd;
